export default __webpack_public_path__ + "static/media/intelly_logo.7527c4c3.png";